const rankingItems = [
  { rank: 1, title: '红桃视频 · 年度悬疑神作', heat: '热播指数 9.8', change: 'new', category: '电影' },
  { rank: 2, title: '西瓜视频免费 · 喜剧之王合集', heat: '热播指数 9.7', change: 'up', category: '合集' },
  { rank: 3, title: '茄子视频 · HBO史诗巨制', heat: '热播指数 9.6', change: 'up', category: '剧集' },
  { rank: 4, title: '小蓝视频 · 七月最热新番', heat: '热播指数 9.5', change: 'new', category: '动漫' },
  { rank: 5, title: '芒果视频 · 声入人心S2', heat: '热播指数 9.4', change: 'up', category: '综艺' },
  { rank: 6, title: '久久视频 · 港片修复合集', heat: '热播指数 9.3', change: 'down', category: '经典' },
  { rank: 7, title: '红桃视频 · 科幻巨制系列', heat: '热播指数 9.2', change: 'up', category: '电影' },
];

const changeIcons: Record<string, { icon: string; color: string }> = {
  new: { icon: 'ri-sparkling-line', color: 'text-accent-500' },
  up: { icon: 'ri-arrow-up-line', color: 'text-green-500' },
  down: { icon: 'ri-arrow-down-line', color: 'text-red-400' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            热播榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            实时热播排行榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            基于全平台播放量与用户互动数据实时更新的热门内容榜单
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={item.title}
              href="#carousel"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-50 transition-colors cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className="flex-shrink-0 w-8 text-center">
                {item.rank <= 3 ? (
                  <span
                    className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-sm font-bold ${
                      item.rank === 1
                        ? 'bg-primary-500 text-background-50'
                        : item.rank === 2
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-secondary-500 text-background-50'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  <span className="px-1.5 py-0.5 rounded bg-background-200 text-xs text-foreground-500 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                <i className={`${changeIcons[item.change].icon} ${changeIcons[item.change].color} text-sm`}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}